export default {
    breadcrumbs: {
        company: 'Компания',
        my_company: 'Моя компания',
        preview: 'Профиль компании',
    },
    tabs: {
        profile: 'Профиль',
        personal_details: 'Настройки',
        settings: 'Настройки',
        gallery: 'Галерея',
        locations: 'Местоположения',
        services: 'Услуги',
        users: 'Пользователи',
        inactivity: 'Неактивность',
        discount: 'Скидки',
        invoices: 'Счета',
        clients: 'Клиенты',
        client: 'Клиент',
        chart: 'Статистика',
        reminder: 'Напоминание',
        performers: 'Сотрудники',
    },
    offer_tabs: {
        active: 'Активные ({number})',
        renewal: 'Для продления ({number})',
        expired: 'Истекшие ({number})',
    },
    buttons: {
        upload_company_logo: 'Загрузить логотип компании',
        change_cover_photo: 'Изменить фото',
        add_inactivity: 'Добавить неактивность',
        add_discount: 'Добавить скидку',
    },
    no_added_inactivity: 'У вас нет добавленной неактивности!',
    no_added_invoice: 'У вас нет счетов!',
    delete_company: 'Удалить компанию',
    reactivate_company: 'Активировать компанию',
    successfully_deleted: 'Компания успешно удалена',
    successfully_reactivated: 'Компания успешно активирована',
    delete_company_modal_heading: 'Вы уверены, что хотите деактивировать компанию?',
    activate_company_modal_heading: 'Вы уверены, что хотите снова активировать компанию?',
    no_added_reminders: 'У вас нет добавленных напоминаний!',
    outstandingsAmountCompanies: 'У нескольких ваших компаний есть задолженности. Пожалуйста, погасите их.',
    outstandingsAmountCompany: 'У вас задолженность {n} {m} в компании {c}. Пожалуйста, погасите её в ближайшее время.',
    search_performer: 'Исполнитель поиска',

    errors: {
        not_found: 'Компания не найдена',
        already_active: 'Компания уже активна',
        is_in_debt: 'Пожалуйста, оплатите свои долги',
    },
}
